import { useTranslation } from 'react-i18next';
import useSWR, { SWRConfiguration } from 'swr';
import { CustomFieldOption } from '../model/types';
import { fetcherWithToken } from '../utils/fetchers';
import { AutocompleteResponseType } from './autocomplete/useAutocompleteSuggestionsByFieldKey';
import useSWRCacheKeys from './useSWRCacheKeys';

export default function useChannelsAsOptions(config: SWRConfiguration = {}) {
    const { t } = useTranslation('reports');
    const keys = useSWRCacheKeys(`/field-values/channel/options`);

    const { data, isLoading, mutate } = useSWR<AutocompleteResponseType<CustomFieldOption>>(keys, fetcherWithToken, {
        ...config
    });

    return {
        data: data?.result?.map(({ value, label }) => ({
            value,
            label: t(`channelOptions.${label}` as any)
        })),
        isLoading,
        mutate
    };
}
